export default "__VITE_ASSET__COXvGapy__"